var $b4e14b6b8da86996$exports = {};
// src/index.ts
// Dapatkan elemen-elemen DOM
const $b4e14b6b8da86996$var$plainTextarea = document.getElementById('plainText');
const $b4e14b6b8da86996$var$encodedTextarea = document.getElementById('urlEncodedText');
const $b4e14b6b8da86996$var$spaceEncodingSelect = document.getElementById('spaceEncoding');
const $b4e14b6b8da86996$var$spaceLabel = document.getElementById('spaceLabel');
const $b4e14b6b8da86996$var$conversionModeSelect = document.getElementById('conversionMode');
const $b4e14b6b8da86996$var$plainLabel = document.getElementById('plainLabel');
const $b4e14b6b8da86996$var$encodedLabel = document.getElementById('encodedLabel');
const $b4e14b6b8da86996$var$statusMessage = document.getElementById('statusMessage');
const $b4e14b6b8da86996$var$langButton = document.getElementById('langButton');
const $b4e14b6b8da86996$var$modeLabel = document.getElementById('modeLabel');
// --- Data: Objek Terjemahan (Memuat Semua Konten Statis) ---
const $b4e14b6b8da86996$var$translations = {
    en: {
        title: 'Universal Encoder, Decoder & Hash',
        subtitle: 'Convert text two-way or generate SHA-256 Hash (One-Way) in real-time.',
        mode: 'Select Mode:',
        space: 'Space Encoding:',
        plainLabel: 'Plain Text Input',
        encodedLabel: 'Encoded / Hashed Output',
        plainPlaceholder: 'Enter plain text here...',
        footerText: 'Built by {developerLink}. Fast, Free, and Open Source.',
        developerName: '@bilbudan',
        developerUrl: 'https://www.linkedin.com/in/bilal-abudan-2485b6110/',
        encodedPlaceholder: '...or enter encoded/hashed text here (except SHA-256).',
        statusDefault: 'Select conversion mode and type your text.',
        statusSuccess: 'Conversion successful.',
        errorEncoding: "\u26A0\uFE0F Error Encoding:",
        errorDecoding: "\u26A0\uFE0F Error Decoding:",
        errorHash: 'SHA-256 is a Hashing (One-Way) function, cannot be decoded.',
        urlOption1: '%20 (URI Default)',
        urlOption2: 'Space to \'+\' (Form Data - Space Only)',
        hashOutput: 'SHA-256 Hash Output (64 Chars)',
        base64Label: 'Base64 Encoded Text',
        urlLabel: 'URL Encoded Text',
        // SEO Content
        seoTitle1: 'What is a Universal Encoder/Decoder and Hashing Tool?',
        seoP1: "This tool is a Real-Time Web Utility designed to assist Developers, Data Analysts, and Security Professionals. With support for three main modes\u2014URL Encoding, Base64 Encoding, and SHA-256 Hashing\u2014you can instantly convert, secure, or verify data without installing any software.",
        seoTitle2: 'URL Encoding and Decoding (Percent Encoding)',
        seoP2: 'URL Encoding, often called **Percent Encoding**, is a standard for transforming "unsafe" characters or those with special meaning into a format that can be safely transmitted via a URL (Uniform Resource Locator).',
        seoSub1: 'Why is URL Encoding Important?',
        seoUl1: [
            'Transmission Safety: Characters like spaces, question marks (?), and ampersands (&) must be converted to prevent them from breaking the URL\'s syntactic structure.',
            'Space Standard: You can choose to encode spaces into **`%20` (URI Default)** or into **`+` (Form Data)**, depending on the HTTP request need (especially for `application/x-www-form-urlencoded` forms).',
            'SEO Usage: This tool is essential for testing URL structure and query parameters.'
        ],
        seoExample1: 'Example: `https://example.com/?query=Cool Article Title!` encodes to `https%3A%2F%2Fexample.com%2F%3Fquery%3DCool%2BArticle%2BTitle%21` (when using space \'+\').',
        seoTitle3: 'Base64 Encoding and Decoding',
        seoP3: 'Base64 is a popular encoding scheme designed to convert binary data (like images, files, or non-ASCII character strings) into a safe ASCII text representation. This makes it ideal for transferring binary data over text-based mediums, such as email (MIME) or JSON data.',
        seoSub2: 'When is Base64 Used?',
        seoUl2: [
            'Data URI: Embedding images or fonts directly into CSS or HTML code.',
            'Data Transfer: Sending complex binary data via APIs or security tokens (e.g., JWT).',
            'UTF-8 Support: This tool supports the conversion of Bahasa Indonesia and Emoji characters due to its use of the UTF-8 standard.'
        ],
        seoTitle4: 'SHA-256 Hashing (One-Way Security)',
        seoP4: 'SHA-256 (Secure Hash Algorithm 256-bit) is an irreversible, one-way cryptographic hashing function. This tool uses modern cryptographic APIs in your browser to generate a unique **64-hexadecimal character** hash for every input.',
        seoSub3: 'Main Functions of SHA-256',
        seoUl3: [
            'Integrity Verification: Used to check that downloaded files or transmitted data have not been tampered with (corruption).',
            'Password Storage: User passwords must be hashed before being stored in a database for security reasons.',
            'Fixed Output: The SHA-256 output length is always 64 hexadecimal characters, regardless of the input length (Avalanche Effect).'
        ],
        langText: 'Bahasa Indonesia',
        langCode: 'id'
    },
    id: {
        title: 'Universal Encoder, Decoder & Hash',
        subtitle: 'Konversi teks dua arah atau buat Hash SHA-256 (One-Way) secara real-time.',
        mode: 'Pilih Mode:',
        space: 'Space Encoding:',
        plainLabel: 'Plain Text Input',
        encodedLabel: 'Encoded / Hashed Output',
        plainPlaceholder: 'Masukkan teks biasa di sini...',
        footerText: 'Dibuat oleh {developerLink}. Cepat, Gratis, dan Sumber Terbuka.',
        developerName: '@bilbudan',
        developerUrl: 'https://www.linkedin.com/in/bilal-abudan-2485b6110/',
        encodedPlaceholder: '...atau masukkan teks yang sudah di-encode/hash di sini (kecuali SHA-256).',
        statusDefault: 'Pilih mode konversi dan ketik teks Anda.',
        statusSuccess: 'Konversi berhasil.',
        errorEncoding: "\u26A0\uFE0F Error Encoding:",
        errorDecoding: "\u26A0\uFE0F Error Decoding:",
        errorHash: 'SHA-256 adalah Hashing (One-Way), tidak dapat di-decode.',
        urlOption1: '%20 (URI Default)',
        urlOption2: 'Spasi ke \'+\' (Form Data - Hanya Spasi)',
        hashOutput: 'SHA-256 Hash Output (64 Karakter)',
        base64Label: 'Teks Base64 Terenkripsi',
        urlLabel: 'Teks URL Terenkripsi',
        // SEO Content
        seoTitle1: 'Apa Itu Universal Encoder/Decoder dan Hashing Tool?',
        seoP1: "Alat ini adalah Utilitas Web Real-Time yang dirancang untuk membantu Pengembang, Analis Data, dan Profesional Keamanan. Dengan dukungan tiga mode utama\u2014URL Encoding, Base64 Encoding, dan SHA-256 Hashing\u2014Anda dapat mengkonversi, mengamankan, atau memverifikasi data secara instan tanpa perlu menginstal perangkat lunak apa pun.",
        seoTitle2: 'URL Encoding dan Decoding (Percent Encoding)',
        seoP2: 'URL Encoding, atau yang sering disebut **Percent Encoding**, adalah standar untuk mengubah karakter yang "tidak aman" atau memiliki arti khusus menjadi format yang dapat ditransmisikan secara aman melalui URL (Uniform Resource Locator).',
        seoSub1: 'Mengapa URL Encoding Penting?',
        seoUl1: [
            'Keamanan Transmisi: Karakter seperti spasi, tanda tanya (?), dan ampersand (&) harus diubah agar tidak merusak struktur sintaksis URL.',
            'Standar Spasi: Anda dapat memilih untuk meng-encode spasi menjadi **`%20` (URI Default)** atau menjadi **`+` (Form Data)**, tergantung pada kebutuhan request HTTP (terutama untuk formulir `application/x-www-form-urlencoded`).',
            'Penggunaan SEO: Alat ini sangat penting untuk pengujian struktur URL dan parameter query.'
        ],
        seoExample1: 'Contoh: `https://example.com/?query=Judul Artikel Keren!` di-encode menjadi `https%3A%2F%2Fexample.com%2F%3Fquery%3DJudul%2BArtikel%2BKeren%21` (jika menggunakan spasi \'+\').',
        seoTitle3: 'Base64 Encoding dan Decoding',
        seoP3: 'Base64 adalah skema encoding yang populer yang dirancang untuk mengkonversi data biner (seperti gambar, file, atau string karakter non-ASCII) menjadi representasi teks ASCII yang aman. Hal ini membuatnya ideal untuk mentransfer data biner melalui media berbasis teks, seperti email (MIME) atau data JSON.',
        seoSub2: 'Kapan Base64 Digunakan?',
        seoUl2: [
            'Data URI: Menyematkan gambar atau font langsung ke dalam kode CSS atau HTML.',
            'Transfer Data: Mengirim data biner kompleks melalui API atau token keamanan (misalnya, JWT).',
            'UTF-8 Support: Alat ini mendukung konversi teks karakter Bahasa Indonesia dan Emoji karena menggunakan standar UTF-8.'
        ],
        seoTitle4: 'SHA-256 Hashing (One-Way Security)',
        seoP4: 'SHA-256 (Secure Hash Algorithm 256-bit) adalah fungsi hashing kriptografi satu arah yang tidak dapat dibalikkan (irreversible). Alat ini menggunakan API kriptografi modern di browser Anda untuk menghasilkan Hash **64 karakter heksadesimal** yang unik untuk setiap input.',
        seoSub3: 'Fungsi Utama SHA-256',
        seoUl3: [
            'Verifikasi Integritas: Digunakan untuk memverifikasi bahwa file yang diunduh atau data yang dikirim tidak mengalami perubahan (korupsi).',
            'Penyimpanan Kata Sandi: Password pengguna harus di-hash sebelum disimpan di database untuk alasan keamanan.',
            'Output Tetap: Panjang output SHA-256 selalu 64 karakter heksadesimal, terlepas dari panjang input (efek longsor/Avalanche Effect).'
        ],
        langText: 'English',
        langCode: 'en'
    }
};
let $b4e14b6b8da86996$var$currentLang = 'en'; // Default bahasa adalah Inggris
// Fungsi Utama untuk mengubah tampilan UI berdasarkan bahasa
function $b4e14b6b8da86996$var$applyTranslations(lang) {
    const t = $b4e14b6b8da86996$var$translations[lang];
    $b4e14b6b8da86996$var$currentLang = lang;
    // Header
    document.getElementById('mainTitle').textContent = t.title;
    document.getElementById('subTitle').textContent = t.subtitle;
    // Option Bar
    $b4e14b6b8da86996$var$modeLabel.textContent = t.mode;
    $b4e14b6b8da86996$var$spaceLabel.textContent = t.space;
    // Textarea Labels
    $b4e14b6b8da86996$var$plainLabel.textContent = t.plainLabel;
    $b4e14b6b8da86996$var$encodedLabel.textContent = t.encodedLabel;
    $b4e14b6b8da86996$var$plainTextarea.placeholder = t.plainPlaceholder;
    $b4e14b6b8da86996$var$encodedTextarea.placeholder = t.encodedPlaceholder;
    // Dropdown Options (untuk Space Encoding)
    const spaceOptions = $b4e14b6b8da86996$var$spaceEncodingSelect.options;
    spaceOptions[0].textContent = t.urlOption1;
    spaceOptions[1].textContent = t.urlOption2;
    // Status Button/Message
    $b4e14b6b8da86996$var$langButton.textContent = t.langText;
    $b4e14b6b8da86996$var$langButton.setAttribute('data-lang', t.langCode);
    // Status Message
    $b4e14b6b8da86996$var$statusMessage.textContent = t.statusDefault;
    $b4e14b6b8da86996$var$statusMessage.classList.remove('error');
    // FIX: Konten Footer (Implementasi Link yang Dapat Diklik dan Aman)
    const footerTextElement = document.getElementById('footerText');
    // Bersihkan konten lama
    footerTextElement.innerHTML = '';
    const fullFooterText = t.footerText;
    // Pisahkan teks menggunakan placeholder {developerLink}
    const parts = fullFooterText.split('{developerLink}');
    // 1. Tambahkan bagian teks pertama
    if (parts[0]) footerTextElement.appendChild(document.createTextNode(parts[0]));
    // 2. Buat elemen <a>
    const developerLink = document.createElement('a');
    developerLink.href = t.developerUrl;
    developerLink.textContent = t.developerName;
    developerLink.target = '_blank'; // Buka di tab baru
    developerLink.rel = 'noopener noreferrer';
    footerTextElement.appendChild(developerLink);
    // 3. Tambahkan bagian teks kedua
    if (parts[1]) footerTextElement.appendChild(document.createTextNode(parts[1]));
    // END FIX: Footer
    // Konten SEO (Perlu disesuaikan dengan ID di HTML)
    document.getElementById('seoTitle1').textContent = t.seoTitle1;
    document.getElementById('seoP1').textContent = t.seoP1;
    document.getElementById('seoTitle2').textContent = t.seoTitle2;
    // Perlu update P, H3, UL, dan Example box secara manual
    const seoSection2 = document.getElementById('seoTitle2')?.parentElement;
    if (seoSection2) {
        seoSection2.querySelector('p:nth-of-type(1)').innerHTML = t.seoP2;
        seoSection2.querySelector('h3:nth-of-type(1)').textContent = t.seoSub1;
        const ul1 = seoSection2.querySelector('ul');
        ul1.innerHTML = t.seoUl1.map((item)=>`<li>${item}</li>`).join('');
        document.getElementById('seoExample1').textContent = t.seoExample1;
    }
    // Section 3
    document.getElementById('seoTitle3').textContent = t.seoTitle3;
    const seoSection3 = document.getElementById('seoTitle3')?.parentElement;
    if (seoSection3) {
        seoSection3.querySelector('p:nth-of-type(1)').innerHTML = t.seoP3;
        seoSection3.querySelector('h3:nth-of-type(1)').textContent = t.seoSub2;
        const ul2 = seoSection3.querySelector('ul');
        ul2.innerHTML = t.seoUl2.map((item)=>`<li>${item}</li>`).join('');
    }
    // Section 4
    document.getElementById('seoTitle4').textContent = t.seoTitle4;
    const seoSection4 = document.getElementById('seoTitle4')?.parentElement;
    if (seoSection4) {
        seoSection4.querySelector('p:nth-of-type(1)').innerHTML = t.seoP4;
        seoSection4.querySelector('h3:nth-of-type(1)').textContent = t.seoSub3;
        const ul3 = seoSection4.querySelector('ul');
        ul3.innerHTML = t.seoUl3.map((item)=>`<li>${item}</li>`).join('');
    }
    // Setelah mengganti bahasa, panggil updateUI untuk menyesuaikan label Hash/Decode
    $b4e14b6b8da86996$var$updateUI($b4e14b6b8da86996$var$conversionModeSelect.value);
}
// Fungsi untuk mengganti bahasa
function $b4e14b6b8da86996$var$toggleLanguage() {
    const newLang = $b4e14b6b8da86996$var$langButton.getAttribute('data-lang');
    $b4e14b6b8da86996$var$applyTranslations(newLang);
    document.documentElement.lang = newLang;
}
// Tambahkan Event Listener ke Tombol
document.addEventListener('DOMContentLoaded', ()=>{
    $b4e14b6b8da86996$var$langButton.addEventListener('click', $b4e14b6b8da86996$var$toggleLanguage);
});
// --- FUNGSI ENCODING/DECODING/HASHING (Tidak Berubah) ---
function $b4e14b6b8da86996$var$encodeURL(text, spaceType) {
    let encoded = encodeURIComponent(text);
    if (spaceType === 'plus') encoded = encoded.replace(/%20/g, '+');
    return encoded;
}
function $b4e14b6b8da86996$var$decodeURL(text, spaceType) {
    let decodedText = text;
    if (spaceType === 'plus') decodedText = decodedText.replace(/\+/g, ' ');
    return decodeURIComponent(decodedText);
}
function $b4e14b6b8da86996$var$encodeBase64(text) {
    return btoa(unescape(encodeURIComponent(text)));
}
function $b4e14b6b8da86996$var$decodeBase64(text) {
    return decodeURIComponent(escape(atob(text)));
}
async function $b4e14b6b8da86996$var$hashSHA256(text) {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
// --- UTILITY FUNGSI DAN LOGIKA UTAMA ---
function $b4e14b6b8da86996$var$getConversionFunctions(mode) {
    const t = $b4e14b6b8da86996$var$translations[$b4e14b6b8da86996$var$currentLang];
    if (mode === 'base64') return {
        encode: (text, spaceType)=>Promise.resolve($b4e14b6b8da86996$var$encodeBase64(text)),
        decode: $b4e14b6b8da86996$var$decodeBase64,
        errorText: t.errorDecoding + ' Base64 text is invalid.',
        isHashing: false
    };
    else if (mode === 'sha256') return {
        encode: $b4e14b6b8da86996$var$hashSHA256,
        decode: ()=>'',
        errorText: t.errorHash,
        isHashing: true
    };
    else return {
        encode: (text, spaceType)=>Promise.resolve($b4e14b6b8da86996$var$encodeURL(text, spaceType)),
        decode: $b4e14b6b8da86996$var$decodeURL,
        errorText: t.errorDecoding + ' URL encoded text is invalid.',
        isHashing: false
    };
}
// Adaptasi UI berdasarkan mode yang dipilih
function $b4e14b6b8da86996$var$updateUI(mode) {
    const isHashing = mode === 'sha256';
    const t = $b4e14b6b8da86996$var$translations[$b4e14b6b8da86996$var$currentLang];
    // Tentukan visibilitas dan status readonly
    $b4e14b6b8da86996$var$spaceEncodingSelect.style.display = mode === 'url' ? 'inline-block' : 'none';
    $b4e14b6b8da86996$var$spaceLabel.style.display = mode === 'url' ? 'inline-block' : 'none';
    $b4e14b6b8da86996$var$encodedTextarea.readOnly = isHashing;
    // FIX: Ubah Label agar mendukung multibahasa
    if (isHashing) {
        $b4e14b6b8da86996$var$plainLabel.textContent = t.plainLabel;
        $b4e14b6b8da86996$var$encodedLabel.textContent = t.hashOutput;
    } else if (mode === 'base64') {
        $b4e14b6b8da86996$var$plainLabel.textContent = t.plainLabel + ' (UTF-8)';
        $b4e14b6b8da86996$var$encodedLabel.textContent = t.base64Label; // Menggunakan terjemahan dari object translations
    } else {
        $b4e14b6b8da86996$var$plainLabel.textContent = t.plainLabel;
        $b4e14b6b8da86996$var$encodedLabel.textContent = t.urlLabel; // Menggunakan terjemahan dari object translations
    }
    // Jalankan konversi ulang untuk membersihkan/memperbarui
    $b4e14b6b8da86996$var$convertAndDisplayPlain();
}
// --- FUNGSI INTI KONVERSI (ASYNC UNTUK SHA-256) ---
async function $b4e14b6b8da86996$var$convertAndDisplayPlain() {
    const plainText = $b4e14b6b8da86996$var$plainTextarea.value;
    const mode = $b4e14b6b8da86996$var$conversionModeSelect.value;
    const spaceType = $b4e14b6b8da86996$var$spaceEncodingSelect.value;
    const { encode: encode } = $b4e14b6b8da86996$var$getConversionFunctions(mode);
    const t = $b4e14b6b8da86996$var$translations[$b4e14b6b8da86996$var$currentLang];
    if (plainText.length === 0) {
        $b4e14b6b8da86996$var$encodedTextarea.value = '';
        $b4e14b6b8da86996$var$statusMessage.textContent = t.statusDefault;
        $b4e14b6b8da86996$var$statusMessage.classList.remove('error');
        return;
    }
    try {
        $b4e14b6b8da86996$var$encodedTextarea.value = await encode(plainText, spaceType);
        $b4e14b6b8da86996$var$statusMessage.textContent = t.statusSuccess;
        $b4e14b6b8da86996$var$statusMessage.classList.remove('error');
    } catch (e) {
        $b4e14b6b8da86996$var$statusMessage.textContent = `${t.errorEncoding} ${e.message}`;
        $b4e14b6b8da86996$var$statusMessage.classList.add('error');
    }
}
// Handler 1: Dari Plain Text ke Encoded Text
function $b4e14b6b8da86996$var$handlePlainTextChange() {
    $b4e14b6b8da86996$var$convertAndDisplayPlain();
}
// Handler 2: Dari Encoded Text ke Plain Text (Diabaikan saat mode Hashing)
function $b4e14b6b8da86996$var$handleEncodedTextChange() {
    const mode = $b4e14b6b8da86996$var$conversionModeSelect.value;
    const t = $b4e14b6b8da86996$var$translations[$b4e14b6b8da86996$var$currentLang];
    if (mode === 'sha256') return;
    const encodedText = $b4e14b6b8da86996$var$encodedTextarea.value;
    const spaceType = $b4e14b6b8da86996$var$spaceEncodingSelect.value;
    const { decode: decode, errorText: errorText } = $b4e14b6b8da86996$var$getConversionFunctions(mode);
    if (encodedText.length === 0) {
        $b4e14b6b8da86996$var$plainTextarea.value = '';
        $b4e14b6b8da86996$var$statusMessage.textContent = t.statusDefault;
        $b4e14b6b8da86996$var$statusMessage.classList.remove('error');
        return;
    }
    // Matikan handler 'input' pada plainTextarea untuk mencegah loop tak terbatas
    $b4e14b6b8da86996$var$plainTextarea.removeEventListener('input', $b4e14b6b8da86996$var$handlePlainTextChange);
    try {
        $b4e14b6b8da86996$var$plainTextarea.value = decode(encodedText, spaceType);
        $b4e14b6b8da86996$var$statusMessage.textContent = t.statusSuccess;
        $b4e14b6b8da86996$var$statusMessage.classList.remove('error');
    } catch (e) {
        $b4e14b6b8da86996$var$statusMessage.textContent = errorText;
        $b4e14b6b8da86996$var$statusMessage.classList.add('error');
    }
    // Aktifkan kembali handler
    $b4e14b6b8da86996$var$plainTextarea.addEventListener('input', $b4e14b6b8da86996$var$handlePlainTextChange);
}
// --- EVENT LISTENERS ---
document.addEventListener('DOMContentLoaded', ()=>{
    // 1. Input Utama
    $b4e14b6b8da86996$var$plainTextarea.addEventListener('input', $b4e14b6b8da86996$var$handlePlainTextChange);
    $b4e14b6b8da86996$var$encodedTextarea.addEventListener('input', $b4e14b6b8da86996$var$handleEncodedTextChange);
    // 2. Handler Pilihan Mode
    $b4e14b6b8da86996$var$conversionModeSelect.addEventListener('change', ()=>{
        $b4e14b6b8da86996$var$updateUI($b4e14b6b8da86996$var$conversionModeSelect.value);
    });
    // 3. Handler Pilihan URL Encoding
    $b4e14b6b8da86996$var$spaceEncodingSelect.addEventListener('change', ()=>{
        if ($b4e14b6b8da86996$var$conversionModeSelect.value === 'url') $b4e14b6b8da86996$var$convertAndDisplayPlain();
    });
    // Inisialisasi UI awal dengan bahasa default (English)
    $b4e14b6b8da86996$var$applyTranslations('en');
});


//# sourceMappingURL=url-encoder-app.3147e313.js.map
